import { ActionGroupTypes, ActionStatusTypes } from "../../../enum/ActionStatusTypes";
import * as logger from "../../../logger";
import { getNodeById } from "../../../nodeSelector";
import * as nodeUtils from "../../../utils/nodeUtils";
import * as systemUtils from "../../../utils/systemUtils";
import { ACTION_PREFIX_PARAMETER } from "./abstract/parameterAbstract";

const _action = `${ACTION_PREFIX_PARAMETER}_create`;
const _header = `Create parameter`;

export const addParameter = (root, idParent, body, index) => {
  const _payload = addParameterLogic(root, idParent, body, index);

  logger.logAction(_action, _payload, ACTION_PREFIX_PARAMETER);

  return { root, info: _payload };
};

const addParameterLogic = (root, idParent, body, index) => {
  const { data: _nodeParent } = getNodeById(root, idParent);
  
  if (!_nodeParent) {
    throw new Error("Parent node not found");
  }
  const _indexParsed = index ?? nodeUtils.getParameters(_nodeParent).length;

  const fun = (e) => e.splice(_indexParsed, 0, body);
  nodeUtils.modifyParameters(_nodeParent, fun, false);

  return generatePayload(body, _indexParsed, _nodeParent);
};

//--------------------------------------------------------------------------------

const generatePayload = (body, index, nodeParent) => {
  const _payload = {
    group: ActionGroupTypes.ADD,
    status: ActionStatusTypes.INDIFFERENT,
    action: _action,
    time: systemUtils.getTimestamp(),
    header: _header,
    description: generatePayloadDescription(nodeParent),
    node: systemUtils.createDeepCopy(body),
    uuid: nodeUtils.getUUID(body),
    uuidParent: nodeUtils.getUUID(nodeParent),
    index: index,
  };

  return _payload;
};

const generatePayloadDescription = (nodeParent) => {

  if (nodeUtils.isRoot(nodeParent)) {
    return `Add a new top global parameter.`;
  }

  if (nodeUtils.isParameterGlobal(nodeParent)) {
    return `Add a new nested global parameter to '${nodeUtils.getName(nodeParent)}'.`;
  }

  if (nodeUtils.isFunction(nodeParent)) {
    return `Add a new parameter to '${nodeUtils.getName(nodeParent)}'.`;
  }

  return `Add a new nested parameter to '${nodeUtils.getName(nodeParent)}'.`;
}